"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Slide_1 = tslib_1.__importDefault(require("@mui/material/Slide"));
const DefaultDialogTransition = (0, react_1.forwardRef)((props, ref) => {
    return (0, jsx_runtime_1.jsx)(Slide_1.default, Object.assign({ direction: 'up' }, props, { ref: ref }));
});
exports.default = DefaultDialogTransition;
